import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  { apiName: "pickTicketHeaderText", component: "FrmTextField" },
  {
    apiName: "pickTicketNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.PICK_TICKET.fullString,
    hasInputLabel: true,
  },
  { apiName: "pickTicketFooter", component: "FrmResizeTextField" },
  {
    apiName: "replyEmailPickTicket",
    component: "FrmTextField",
    maxLength: 255,
  },
  { apiName: "pickTicketEmailText", component: "FrmResizeTextField" },
  { apiName: "pickTicketSerialsLots", component: "FrmCheckbox" },
  { apiName: "defaultCCPickTicket", component: "FrmTextField", maxLength: 255 },
];
